import { render, staticRenderFns } from "./ProjectDeliverableComponent.vue?vue&type=template&id=e1fad74e&"
import script from "./ProjectDeliverableComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliverableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports